var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 60",
    role: "img",
    "aria-label": "Epic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 198,
    height: 58,
    rx: 10,
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 1.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 38,
    textAnchor: "middle",
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 28,
    fontWeight: 700,
    fill: "#b11e1e",
    letterSpacing: 1
  }, "Epic")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpic);
export default __webpack_public_path__ + "static/media/epic.fad73d479dcc560a73184f88ddbdbbba.svg";
export { ForwardRef as ReactComponent };